/**
 * @param {string} selector
 * @param {string} type
 */
let sortingTable = (selector, type) => {

  const items = document.querySelectorAll(selector);

  let priority = {};

  let searchParams = new URLSearchParams(window.location.search);

  if( searchParams.has('sorts[0][field]') ) {
    priority['0'] = {by: searchParams.get('sorts[0][field]'), order: searchParams.get('sorts[0][order]')};
  }

  if( searchParams.has('sorts[1][field]') && type != 'one' ) {
    priority['1'] = {by: searchParams.get('sorts[1][field]'), order: searchParams.get('sorts[1][order]')};
  }



  items.forEach((item) => {

    if( item.getAttribute("data-sort-by") ) {

      let sortPriority = item.getAttribute("data-sort-priority")
      if( sortPriority === 0 ) {
        priority['0'] = {by: item.getAttribute("data-sort-by"), order: item.getAttribute("data-sort-order")};
      }
      else if( sortPriority === 1 ) {
        priority['1'] = {by: item.getAttribute("data-sort-by"), order: item.getAttribute("data-sort-order")};
      }

      item.addEventListener('click', () => {

        let by = item.getAttribute("data-sort-by")
        let order = item.getAttribute("data-sort-order")

        if( order === 'asc' ) {
          order = 'desc';
        }
        else {
          order = 'asc';
        }

        if( priority.hasOwnProperty('0') && priority['0']['by'] === by ) {
          priority['0'] = {by: by, order: order};
        }
        else if( priority.hasOwnProperty('1') && priority['1']['by'] === by && type !== 'one' ) {
          priority['1'] = {by: by, order: order};
        }
        else if( !priority.hasOwnProperty('0') ) {
          priority['0'] = {by: by, order: order};
        }
        else if( !priority.hasOwnProperty('1') && type !== 'one' ) {
          priority['1'] = {by: by, order: order};
        }
        else if( type !== 'one') {
          priority['0'] = priority['1'];
          priority['1'] = {by: by, order: order};
        }
        else if( type === 'one') {
          priority['0'] = {by: by, order: order};
        }


        console.log(window.location.search)

        let searchParams = new URLSearchParams(window.location.search);

        if( searchParams.has('order_id') ) {
          searchParams.delete('order_id')
        }

        if( searchParams.has('user_id') ) {
          searchParams.delete('user_id')
        }

        Object.entries(priority).forEach(([key, value]) => {
          //console.log(key, value)
          searchParams.set('sorts['+key+'][field]', value.by)
          searchParams.set('sorts['+key+'][order]', value.order)
        })

        let newURL = window.location.protocol + "//" + window.location.host + "" + window.location.pathname + '?' + searchParams.toString();

        //console.log(newURL)

        window.location.href = newURL
      });
    }
  });

}

export {
  sortingTable,
}
